// 下载页通用能力：埋点、下载跳转、Toast 提示
// 仅服务于 views/download 下的各 App 下载页，不与其他业务页面混用

/**
 * 埋点上报（优先使用 sendBeacon，保证页面卸载时也能发出）
 * @param {number|string} pageId 页面埋点 ID
 */
export function track(pageId) {
  const reportUrl = "https://api.kid.eletell.com/gate/admin/getPageInterview";
  const params = new URLSearchParams({ pageId });

  if (navigator.sendBeacon) {
    navigator.sendBeacon(reportUrl, params);
  } else {
    fetch(reportUrl, {
      method: "POST",
      body: params,
      keepalive: true, // 告诉浏览器即使页面卸载了也继续在后台发送请求
    });
  }
}

/**
 * 下载跳转（通用逻辑：微信内按需弹遮罩引导；iOS 跳 App Store；安卓跳应用市场，失败提示手动搜索）
 * @param {Object} options
 * @param {number} [options.trackPageId] 下载埋点 pageId，不传则不埋点
 * @param {string} options.iosUrl iOS 跳转地址（App Store）
 * @param {string} options.androidPackage 安卓应用包名（测试期先用测试包名，正式包名后续替换）
 * @param {boolean} [options.wechatMask] 微信内是否弹遮罩引导，默认 true；false 时微信内也直接跳转
 */
export function downloadApp({ trackPageId, iosUrl, androidPackage, wechatMask = true }) {
  if (trackPageId) {
    track(trackPageId);
  }

  const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);

  // 微信内且需要遮罩引导：弹遮罩，不直接跳转
  if (isWeixin && wechatMask) {
    document.querySelector(".mask").style.display = "block";
    return;
  }

  // iOS 跳 App Store
  if (isIOS) {
    window.location.href = iosUrl;
    return;
  }

  // 安卓：跳转应用市场，无法跳转则提示手动去应用市场搜索下载
  redirectToMarket(androidPackage);
}

/**
 * 安卓跳转应用市场（market:// intent）
 * 通过隐藏 iframe 触发，失败时不会把当前页面跳走；
 * 2.5 秒内页面未切走则判定跳转失败，toast 提示手动搜索下载
 * @param {string} packageName 应用包名
 */
function redirectToMarket(packageName) {
  const marketUrl = "market://details?id=" + packageName;
  let redirected = false;
  const markRedirected = () => {
    redirected = true;
  };
  document.addEventListener("visibilitychange", markRedirected);
  window.addEventListener("pagehide", markRedirected);

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = marketUrl;
  document.body.appendChild(iframe);

  setTimeout(() => {
    document.removeEventListener("visibilitychange", markRedirected);
    window.removeEventListener("pagehide", markRedirected);
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
    if (!redirected) {
      showToast("未检测到应用市场，请手动去应用市场搜索下载");
    }
  }, 2500);
}

/**
 * 轻提示（复制成功/失败等）
 * @param {string} message 提示文案
 */
export function showToast(message) {
  const toast = document.createElement("div");
  toast.textContent = message;

  Object.assign(toast.style, {
    position: "fixed",
    bottom: "12%",
    left: "50%",
    transform: "translateX(-50%) translateY(20px)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    color: "#ffffff",
    padding: "10px 20px",
    borderRadius: "20px",
    fontSize: "14px",
    zIndex: "9999",
    whiteSpace: "nowrap",
    opacity: "0",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
    pointerEvents: "none",
  });

  document.body.appendChild(toast);
  toast.offsetTop;
  toast.style.opacity = "1";
  toast.style.transform = "translateX(-50%) translateY(0)";

  setTimeout(() => {
    toast.style.opacity = "0";
    toast.style.transform = "translateX(-50%) translateY(-15px)";
    setTimeout(() => {
      document.body.removeChild(toast);
    }, 300);
  }, 2000);
}
